export default {
	labels: {
		general: {
			phone: "Telefone",
			fall_detection: "Detecção de Quedas",
			timeout_sos_state: "Timeout SOS State",
			timeout_turn_off_screen: "Timeout Turn Off Screen",
			offline_timer: "Temporizador off-line",
			staff: "Funcionários",
			invitations: "Convites",
			send_invitation: "Enviar convite",
			send: "Enviar",
			resend: "Reenviar",
			created: "Criado",
			no_results: "Nenhum resultado encontrado",
			organization: "Organização",
			email: "Email",
			url: "URL",
			billing_email: "Email de cobrança",
			use_policy: "Política de Utilização",
			privacy_policy: "Política de Privacidade",
			terms_of_use: "Termos de Utilização",
			rent_watches: "Alugar relógios",
			seats: "Postos",
			paid: "Paid",
			yearly: "Anual",
			monthly: "Mensal",
			daily: "Diário",
			select: "Selecionar",
			payment_frequency: "Frequência de Pagamento",
			subscribe: "Subscrever",
			service: "Serviço",
			price_by_unit: "Preço por unidade",
			units: "Unidades",
			total: "Total",
			payment: "Pagamento",
			next_payment: "Próximo pagamento",
			auto_renew: "Auto-renovação",
			empty: "Vazio",
			view: "Ver",
			subscription: "Assinatura",
			add_subscription: "Adicionar assinatura",
			transactions: "Transações",
			transaction: "Transação",
			service_period: "Período de serviço",
			subtotal: "Subtotal",
			tax: "Tax",
			account_movement: "Movimento da conta",
			logs: "Logs",
			message: "Mensagem",
			amount: "Montante",
			operation: "Operação",
			slots: "Slots",
			in_use: "Em uso",
			available: "Disponível",
			add_payment_method: "Adicionar método de pagamento",
			current: "Atual",
			active: "Ativo",
			set_active: "Ativar",
			account: "Conta",
			account_personal: "Conta pessoal",
			my_idicare: "Meu IDICARE",
			timezone: "Fuso horário",
			subscriptions: "Subscrições",
			budget: "Orçamento",
			resume: "Resumo",
			account_movements: "Movimentos da conta",
			payment_methods: "Métodos de pagamento",
			birthdate: "Data de nascimento",
			birthday: "Aniversário",
			blood_type: "Tipo sanguíneo",
			color: "Cor",
			comments: "Comentários",
			contact: "Contacto",
			date: "Data",
			description: "Descrição",
			device_type: "Tipo de dispositivo",
			device: "Dispositivo",
			disease: "Doença",
			dose: "Dose",
			end_date: "Data de fim",
			end: "Fim",
			events: "Eventos",
			expire_date: "Data de validade",
			feel: "Sentimento",
			first: "Primeiro",
			gender: "Género",
			height: "Altura",
			hour: "Hora",
			imei: "IMEI",
			in_use: "Em uso",
			insurance: "Seguro",
			last_sync: "Última sincronização",
			last: "Último",
			location: "Localização",
			max: "Max",
			min: "Min",
			max_start: "Sistólica ínicio",
			max_end: "Sistólica fim",
			min_start: "Diastólica início",
			min_end: "Diastólica fim",
			name: "Nome",
			number: "Número",
			options: "Opções",
			picture: "Imagem",
			position: "Posição",
			previous: "Anteriores",
			relation_contact: "Contacto de relação",
			relation: "Relação",
			shape: "Forma",
			start_date: "Data de início",
			start: "Começo",
			state: "Estado",
			status: "Estado",
			today: "Hoje",
			type: "Tipo",
			uptime: "Tempo de atividade",
			value: "Valor",
			week: "Semana",
			weight: "Peso",
			years_old: "Anos",
			urgency: "Urgência",
			person: "Pessoa",
			report: "Relatório",
			day: "Dia",
			month: "Mês",
			year: "Ano",
			minute: "Minuto",
			sos_phone: "Telefone SOS",
			sync_interval_normal: "Intervalo de sincronização no estado normal",
			sync_interval_alert: "Intervalo de sincronização no estado de alerta",
			ok: "OK",
			sos: "SOS",
			false_positive: "Falso positivo",
			no_response: "Nenhuma resposta",
			average: "Média",
			standard_deviation: "Desvio padrão",
			samples: "Amostras",
			systolic: "Sistólica",
			diastolic: "Diastólica",
			fall: "Queda",
			responded: "Respondeu",
			not_responded: "Não respondeu",
			no_reports: "Sem relatórios",
			no_notifications: "Nenhuma notificação",
			subject: "Assunto",
			last_activity: "Última atividade",
			responsible: "Responsável",
			category: "Categoria",
			search_location: "Procurar localização",
			steps: "passos",
			fall_detected: "Queda detectada",
			address: "Morada",
			no: "Não",
			yes: "Sim",
			falling: "Queda",
			geofencing: "Geofencing",
			unresponded: "Não respondido",
			in_progress: "Em progresso",
			done: "Feito",
			cancelled: "Cancelado",
			cancel: "Cancelar",
			open: "Aberto",
			closed: "Fechado",
			see: "Ver",
			file:"Ficheiro",
			take_later: "Tomou mais tarde",
			take: "Tomou",
			skip: "Saltou",
			miss: "Faltou",
			better: "Melhor",
			same: "Mesmo",
			worse: "Pior",
		},
		auth: {
			fullname: "Nome completo",
			email: "Email",
			password: "Senha",
			confirm_password: "Confirme a Senha",
		},
		profile: {
			new_name: "Novo nome",
			new_email: "Novo email",
			old_password: "Senha antiga",
			new_password: "Nova senha",
			confirm_new_password: "Confirme a nova senha",
			personal_information: "Informação pessoal",
			contacts: "Contactos",
			medical_information: "Informação médica",
			family_information: "Informação familiar",
			other_information: "Outra informação",
			social_numbers: "Números sociais",
			insurances: "Seguros",
		},
		alerts: {
			alert_value: "Valor de {value} {units} do utilizador {userName}",
			alert_value_falls: "{value} do utilizador {userName}",
			alert_value_remove_title: "Relógio removido",
			alert_value_remove: "Paciente {userName} removeu o relógio do pulso",
		},
		week: {
			mon: "Seg",
			tue: "Ter",
			wed: "Qua",
			thu: "Qui",
			fri: "Sex",
			sat: "Sab",
			sun: "Dom",
		},
		numbers: {
			adse: "ADSE",
			civil_id: "Civil ID",
			health_number: "Número de utente",
			social_security: "NISS",
			tax_number: "NIF",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/labels/labels_pt.js